<template>
   <div class="col profile-container">
      <div class="profile-pic">
         <img :src="p_image=='no-image' ? 'https://ui-avatars.com/api/??background=0D8ABC&color=F75511&name='+current_user_name :p_image" class="img-fluid">
      </div>
      <div class="profile-info">
         <span class="name">{{current_user_name}}</span>
         <div @click="$bvModal.show('call-mentor')"><a href="javascript://" data-toggle="modal" data-target="#call_details" class="btn btn-primary save-summary gobtn call-btn tour_step_8">Call</a></div>
         <!-- <span class="service-info">Services valid till xx xxxx</span>  -->
      </div>
      <b-modal id="call-mentor" tabindex="-1" centered role="dialog" aria-labelledby="exampleModalCenterTitle" class="modal fade callDetaisl_model" aria-hidden="true" style="display: none;">
         <ul id="myTab" role="tablist" class="nav nav-tabs">
            <li class="nav-item" @click="immediate_call(true)"><a  v-bind:class="{ active: isActive, 'show': hasError }" id="Immediately-tab" data-toggle="tab" href="#Immediately" role="tab" aria-controls="Immediately" aria-selected="false" class="nav-link" >Call Immediately  </a></li>
            <li class="nav-item" @click="immediate_call(false)"><a  v-bind:class="{ active: !isActive, 'show': !hasError }" id="Schedule-tab" data-toggle="tab" href="#Schedule" role="tab" aria-controls="Schedule" aria-selected="true" class="nav-link " >Schedule Call</a></li>
         </ul>
         <div id="myTabContent" class="tab-content">
            <div id="Immediately" role="tabpanel" aria-labelledby="Immediately-tab" v-bind:class="{ active: isActive, 'show': hasError }" class="tab-pane fade">
               <h4 style="padding-bottom: 7px;">Details</h4>
               <div class="details_div"><span class="label_span">Name <span>:</span></span> <span class="input-span">{{current_user_name}}</span></div>
               <div class="details_div"><span class="label_span">Email <span>:</span></span> <span class="input-span">{{current_email}}</span></div>
               <div class="details_div"><span class="label_span">Mobile <span>:</span></span> <span class="input-span">{{current_phone}}</span></div>
               <!-- <div class="details_div"><span class="label_span">Service <span>:</span></span> <span class="input-span">{{current_service}}</span></div> -->
               <br> <button type="button" class="btn btn-primary gobtn Initiate_Call" @click="initiate_call()">Initiate Call</button> 
               <p class="Successfully_message" v-if="is_immediatecall"><b>Call Initiated Successfully!</b></p>
            </div>
            <div id="Schedule" role="tabpanel" aria-labelledby="Schedule-tab" v-bind:class="{ active: !isActive, 'show': !hasError }" class="tab-pane fade ">
              <h4 style="padding-bottom: 7px;">Schedule</h4>
                  <form id="schedule_formid" @submit.prevent="scDataValidateBeforeSubmit" name="schedule_form" class="Schedule_form" novalidate="novalidate">
                     <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left" style="padding-left: 0px;">
                           <input type="hidden" name="unique_id" value="hPDb4Gk1Oy" class="form-control" > 
                           <div id="datepicker" data-date-format="mm-dd-yyyy" class="input-group date"><datepicker :format="customFormatter" v-model="scData.sc_date" placeholder="Date"></datepicker> <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span></div>
                           <span  v-if="$v.scData.sc_date.$error" class="error" style="color:red">
                              <label v-if="!$v.scData.sc_date.required">This field is required</label>
                           </span>
                        </div>   
                        <div class="form-group col-md-6 p-r-0 f-left" style="padding-right: 0px;">
                           <div id="timepicker" class="input-group time">
                               <vue-autosuggest
                              v-model="scData.sc_time"
                              :suggestions="filteredOptions"
                              @input="onInputChange"
                              @selected="onSelectChange"
                              :get-suggestion-value="getSuggestionValue"
                              :input-props="{id:'autosuggest__input', placeholder:'Time'}">
                              <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                                 <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.time}}</div>
                              </div>
                              </vue-autosuggest>
                           </div>
                           <span  v-if="$v.scData.sc_time.$error" class="error" style="color:red">
                              <label v-if="!$v.scData.sc_time.required">This field is required</label>
                           </span>
                        </div>
                     </div>
                     <div class="col-md-12 p-l-r-0 f-left">
                        <textarea rows="4" v-model="scData.sc_msg"  name="topic_message" placeholder="Topic/Message" class=""></textarea>
                        <span  v-if="$v.scData.sc_msg.$error" class="error" style="color:red">
                           <label v-if="!$v.scData.sc_msg.required">This field is required</label>
                        </span>
                     </div>
                     <button type="submit" class="btn btn-primary gobtn Initiate_Call" style="margin-top: 15px;">Schedule Call</button> 
                  <p class="Successfully_message" v-if="is_scheduled"><b>Call Scheduled Successfully!</b></p>
               </form>
            </div>
         </div>
      </b-modal>
   </div>
</template>
<script>
   import moment from 'moment';
   import ls from '../../services/ls';
   import Datepicker from 'vuejs-datepicker';
   import callDetails from '../../services/call_details'
   import { required } from 'vuelidate/lib/validators'
   import { VueAutosuggest } from 'vue-autosuggest';
   export default {
     name: "profileHeader",
     data() {
       return {
          current_user_name:ls.get('_u_name'),
          current_email:ls.get('_u_email'),
          current_phone:ls.get('_u_mobile'),
          current_service:ls.get('_u_service'),
          p_image:ls.get('_u_p_im'),
          isActive: true,
          hasError: true,
          VueAutosuggest,
          is_scheduled:false,
          is_immediatecall:false,
          userVal:{
            testid:"123",
          },
          scData: {
            sc_date:'',
            sc_time:'',
            sc_msg:'',
         },
         suggestions: [
            {
               data: [
                  {'time':'00:00'},
                  {'time':'00:30'},
                  {'time':'01:00'},
                  {'time':'01:30'},
                  {'time':'02:00'},
                  {'time':'02:30'},
                  {'time':'03:00'},
                  {'time':'03:30'},
                  {'time':'04:00'},
                  {'time':'04:30'},
                  {'time':'05:00'},
                  {'time':'05:30'},
                  {'time':'06:00'},
                  {'time':'06:30'},
                  {'time':'07:00'},
                  {'time':'07:30'},
                  {'time':'08:00'},
                  {'time':'08:30'},
                  {'time':'09:00'},
                  {'time':'09:30'},
                  {'time':'10:00'},
                  {'time':'10:30'},
                  {'time':'11:00'},
                  {'time':'11:30'},
                  {'time':'12:00'},
                  {'time':'12:30'},
                  {'time':'13:00'},
                  {'time':'13:30'},
                  {'time':'14:00'},
                  {'time':'14:30'},
                  {'time':'15:00'},
                  {'time':'15:30'},
                  {'time':'16:00'},
                  {'time':'16:30'},
                  {'time':'17:00'},
                  {'time':'17:30'},
                  {'time':'18:00'},
                  {'time':'18:30'},
                  {'time':'19:00'},
                  {'time':'19:30'},
                  {'time':'20:00'},
                  {'time':'20:30'},
                  {'time':'21:00'},
                  {'time':'21:30'},
                  {'time':'22:00'},
                  {'time':'22:30'},
                  {'time':'23:00'},
                  {'time':'23:30'},
                  ]
               }
            ]
       };
     },
     components: {
       Datepicker
     },
     props:['nameUpdate','iscall'],
     watch: {
       nameUpdate:function(name){
         this.current_user_name =name;
         ls.set('_u_name',name)
       }
     },
      validations: {
         scData: {
            sc_date:{
               required
            },
            sc_time:{
               required
            },
            sc_msg:{
               required
            },
         }
      },
     methods: {
        immediate_call:function(data){
          if(data){
            this.isActive = true;
            this.hasError = true;
          }else{
            this.isActive = false;
            this.hasError = false;
          }
        },
        onInputChange(val){
           this.scData.sc_time = val;
        },
        onSelectChange(val){
           this.scData.sc_time = val.item.time;
        },
        scDataValidateBeforeSubmit(){
           this.$v.$touch()
           if(!this.$v.$error){
               callDetails.scPost(this.scData)
                            .then((response) =>{
                  if(response.data.status == "success"){
                     this.is_scheduled = true;  
                     this.$root.$emit('sc_complete');
                     setTimeout(function(){
                        window.location.href="/call_details";
                     },2000)
                  }
                                
               })
           }
        },
        getSuggestionValue(suggestion) {
            return suggestion.item.time;
         },
        customFormatter(date) {
            return moment(date).format("DD-MM-YYYY");
         },
        initiate_call:function(){
            callDetails.post(this.userVal)
                            .then((response) =>{
               if(response.data.status == "success"){
                  this.is_immediatecall = true;
                  // this.$bvModal.hide('call-mentor');
                  // this.$root.$emit('sc_complete');
                  
                  // return false;  
               }
               if(response.data.status == "validation_error"){
                  alert("invalid data");
                  return false;  
               }
            })
         
        }
     },
     computed: {
         filteredOptions() {
            return [
            { 
               data: this.suggestions[0].data.filter(option => {
                  return option.time.toLowerCase().indexOf(this.scData.sc_time.toLowerCase()) > -1;
               })
            }
            ];
         }
      },
     beforeCreate: function() {},
     created: function() {},
     beforeMount: function() {},
     mounted: function() {
   
     }
   };
</script>